import Form from '@searchtrends/webform-processor';

window.hideGoogleMaps = function () {
    document.cookie = "showGoogleMaps=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict";

    location.reload();
}

window.allowGoogleMaps = function () {
    document.cookie = "showGoogleMaps=" + Math.floor(Date.now() / 1000) + "; path=/; SameSite=Strict";
}

window.loadMapsJs = function() {

    let token = document.head.querySelector('meta[name="maps-token"]');
    let script = document.createElement('script');

    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + token.content;

    script.async = true;
    script.defer = true;

    document.head.appendChild(script);
    script.onload = () => {
        initMap();
    }
}

let contactforms = {};
let forms = document.querySelectorAll('form[method="post"]:not(.no-ajax)');
forms.forEach(function (cf, index) {
    contactforms[`sendform_${index}`] = new Form(cf, index).onlyOnce();

    cf.addEventListener('submit', function (e) {
        e.preventDefault();

        contactforms[`sendform_${index}`].post(cf.action)
            .then(response => { console.log(response); });
    });
});

if (document.querySelector('.fxMobile')) {
    document.querySelector('.fxMobile').addEventListener('click', function (e) {
        document.querySelector('.fxMenu').classList.toggle('fxMenu-show');
    })
}

if (document.querySelector('#straal')) {
    document.querySelector('#straal').addEventListener('change', function (e) {
        if (this.selectedIndex === 0) {
            this.classList.add('jumbotron-select-placeholder');
        } else {
            this.classList.remove('jumbotron-select-placeholder');
        }
    })
}

if (document.querySelector('.navbar-search-icon')) {
    document.querySelector('.navbar-search-icon').addEventListener('click', function (e) {
        document.querySelector('.navbar-search').classList.toggle('navbar-search-highlight');
        document.querySelector('.navbar-search-box').classList.toggle('hidden');
    });
}
if (document.querySelector('.navbar-search-chevron')) {
    document.querySelector('.navbar-search-chevron').addEventListener('click', function (e) {
        document.querySelector('.navbar-search').classList.toggle('navbar-search-highlight');
        document.querySelector('.navbar-search-box').classList.toggle('hidden');
    });
}

function productsSwitchSection() {
    let sections = ['vermelding', 'starter', 'sembundel'];
    let hash = window.location.hash.substr(1);

    if(sections.indexOf(hash) >= 0) {
        sections.forEach(function (section) {
            if (document.querySelector(`#products-${section}`)) {
                if (section === hash) {
                    document.querySelector(`#products-${section}`).style.display = '';
                } else {
                    document.querySelector(`#products-${section}`).style.display = 'none';
                }
            }
        });

        document.querySelector(`#${hash}`).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

if (document.querySelector('.products-featurette')) {
    window.onhashchange = productsSwitchSection;

    let hash = window.location.hash.substr(1);
    if (hash !== '') {
        productsSwitchSection();
    }
}


